import { useMemo } from "react";

export const useGetHourTypes = (hourTypes) => {
	return useMemo(() => {
		return [...new Set(hourTypes)]?.filter((item) => item !== undefined);
	}, [hourTypes]);
};
